import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot } from '@angular/router';
import { LoginService } from './login/login.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkLoggedIn(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkLoggedIn(state.url);
  }

  canLoad(route: Route): boolean {
    return this.checkLoggedIn(route.path);
  }

  checkLoggedIn(url: string): boolean {
    if (this.loginService.isLoggedIn) {
      if (this.loginService.currentUser.require_reset) {
        if (url !== '/users/currentUser') {
          this.router.navigate(['/users/currentUser']);
          return false;
        }
      }

      return true;
    }

    // Retain the attempted URL for redirection
    this.loginService.redirectUrl = url;
    this.router.navigate(['/login']);

    return false;
  }
}
